import {
  getWeddingHallFolderImgs,
  getWeddingHallImgs,
  getWeddingHallReviewImgs,
} from "@src/api/weddingHall/weddingHall";
import "./photoTab.scss";
import { PhotoProviderComponent } from "@src/components/partner/photo/Provider";
import PhotoListSection from "@src/components/partner/photo/ListSection";

// 최종 사진 탭 컴포넌트
const WeddingHallPhotoList = ({ partner }: { partner: any; tabId: number }) => {
    const partnerData = {uuid: partner.uuid,};

    return (
      <PhotoProviderComponent
          partnerDataProvider={partnerData}
          apiFunctionProvider={{
          getOfficialPhoto: getWeddingHallImgs, //공식 이미지
          getReviewPhoto: getWeddingHallReviewImgs, //리뷰 이미지
          getFolderPhoto: getWeddingHallFolderImgs, //폴더 이미지
          }}
          partnerTypeProvider="weddinghall" //weddinghall 이라면 weddinghall
          parentTabNumberProvider={3}
      >
        <PhotoListSection activeParentTabId={3} />
      </PhotoProviderComponent>
    );
};

export default WeddingHallPhotoList;